import gsap from 'gsap/all';
import { SplitText } from 'gsap/SplitText';

export function animationTitle({ element, ref, delay, duration, stagger, percentFunction, percent }) {
	//?  Default config opacity-0 in react
	//! Plugin
	gsap.registerPlugin(SplitText);

	//! Config
	const config = {
		delay: 0,
		duration: 0.7,
		stagger: 0.2,
	};

	//! Calculate size in Padding Desktop
	let delta = element.getBoundingClientRect();
	let deltaX = delta.x;
	let deltaW = delta.width;
	ref.current = new SplitText(element, { type: 'lines' });
	element.style.opacity = 1;

	//! Calculate percent-duration
	let getPercent = ref.current.lines.length * (duration || config.duration);
	if (percent) {
		getPercent = (getPercent * percent) / 100;
		percentFunction(getPercent);
	}

	//! Animation
	gsap.to(element, { opacity: 1, duration: 0 });
	gsap.fromTo(
		ref.current.lines,
		{ x: `${-deltaW - deltaX}`, duration: 0 },
		{
			duration: duration ? duration : config.duration,
			stagger: stagger ? stagger : config.stagger,
			x: 0,
			delay: delay ? delay : config.delay,
		}
	);
}
